class HbsUcretTarifetanimDTO {
  id?: number = 0;
  aciklama?: string = "";
  katsayi?: number = 0;
  ekleyenKullanici?: number = null;
  eklemeTarih?: string = "";
  guncelleyenKullanici?: number = null;
  guncellemeTarihi?: string = "";
  ucrethastakarsilar?: string = "H";
  ucrethastakarsilarBool?: boolean = false;
  sozlesmeNo?: string = "";
  tarifeTipi?: number = null;
}
export default HbsUcretTarifetanimDTO;